import React from "react";
import { APP_NAME, PUBLIC_PREFIX_PATH } from "configs/AppConfig";

/**
 * Logo na barra superior e no menu lateral (mesmos arquivos em todos os temas).
 */
const SidebarLogo = ({ collapsed, placement = "sidebar" }) => {
	const src = collapsed
		? `${PUBLIC_PREFIX_PATH}/logo-curto.png`
		: `${PUBLIC_PREFIX_PATH}/logo-comprido.png`;

	if (placement === "header") {
		return (
			<div
				className={`header-nav-logo ${collapsed ? "header-nav-logo--collapsed" : ""}`}
			>
				<img src={src} alt={APP_NAME} className="header-nav-logo__img" />
			</div>
		);
	}

	return (
		<div
			className={`side-nav-logo ${collapsed ? "side-nav-logo--collapsed" : ""}`}
		>
			<img src={src} alt={APP_NAME} className="side-nav-logo__img" />
		</div>
	);
};

export default SidebarLogo;
